import React from "react";
import { 
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Typography, 
  Tooltip,
  TextField,
  Icon
} from "@material-ui/core"
import moment from "moment"
import Util, { ERROR, SUCCESS, handleSubmitFail } from '../../common/Util'
import TakeAwayIcon from "../../common/assets/smallTakeAwayIcon.png"
import DeliveryIcon from "../../common/assets/deliveryIcon.png"
import TableIcon from "../../common/assets/enmesaIcon.png"
const TAKEAWAY_TYPE = 'takeAway';
const DELIVERY_TYPE = 'delivery';
const TABLE_TYPE = 'table'

class TableLiq extends React.PureComponent{
  constructor(props){
    super(props)
    this.headers = ["Fecha", "Nro. de Orden", "Comprador", "Tipo de Envío", "Forma de Pago", "Importe", "Comisión"]
    this.types = {"table":"Mesa", "delivery":"Delivery", "takeAway":"Take Away"}
    this.pay = {"cash":"Efectivo", "credit-card":"Tarjeta"}
    this.state = {body:props.items.slice(0,10), page:0, rowPerPage:10, count:props.items.length}
    this.onChangePage=this.onChangePage.bind(this)
    this.onChangeRowsPerPage=this.onChangeRowsPerPage.bind(this)
  }

  static getDerivedStateFromProps(nextProps,prevState){
    if(nextProps.items&&nextProps.items.length!=prevState.count){
      return {body:nextProps.items.slice(prevState.page,10), count:nextProps.items.length}
    }
  }
  
  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    let body = this.props.items.slice(from,end)
    this.setState({page:newPage, body:body})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    let body = this.props.items.slice(from,end)
    this.setState({rowPerPage:evt.target.value, body:body})
  }

  render(){
    return [
      <Table>
        <TableHead>
          <TableRow>
            {this.headers.map((h)=>{
              return (<TableCell>{h}</TableCell>)
            })}
          </TableRow>
        </TableHead>
        <TableBody>
            {this.state.body.map((b)=>{
              return (
                <TableRow>
                  <TableCell>{Util.formatDateToShow(b.ordDate, false)}</TableCell>
                  <TableCell>{b.ordNumber}</TableCell>
                  <TableCell>{b.tktBuyerName}</TableCell>
                  <TableCell>
                    <Tooltip title={this.types[b.ordType]} placement="right">
                      {b.ordType==TAKEAWAY_TYPE?
                          <img src={TakeAwayIcon} style={{height:"75%", marginLeft:18}} alt="Take Away"/>
                        :
                        (b.ordType==DELIVERY_TYPE?
                          <img src={DeliveryIcon} style={{height:"75%", marginLeft:18}} alt="Delivery"/>
                        : 
                        b.ordType==TABLE_TYPE&&
                          <img src={TableIcon}  style={{height:"75%", marginLeft:18}} alt="Mesa"/> 
                        ) 
                      }
                    </Tooltip>
                  </TableCell>
                  <TableCell>{this.pay[b.ordPaymentMethod]}</TableCell>
                  <TableCell>{Util.formatCurrency(b.ordTotal)}</TableCell>
                  <TableCell>
                    <Tooltip title={Util.formatPercent(b.ordCommisionTaxes)}>
                    <Typography variant="body">{Util.formatCurrency(b.ordCommisionAmount)}</Typography>
                    </Tooltip>
                  </TableCell>
                </TableRow>
            )
            })}
        </TableBody>
      </Table>,
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        labelRowsPerPage="Órdenes por página"
        component="div"
        count={this.state.count}
        rowsPerPage={this.state.rowPerPage}
        page={this.state.page}
        onChangePage={this.onChangePage}
        onChangeRowsPerPage={this.onChangeRowsPerPage}
      />
    ]
  }
}

export default TableLiq


// WEBPACK FOOTER //
// ./src/components/TableLiq/TableLiq.js